export enum Ert {
  Unspecified = '20',
  TelephoneOrder = '21',
  MailOrder = '22',
  OpenNetworksInternet = '24',
  TelevisionOrder = '25',
  RecurringPaymentOpenNetworks = '27',
  RecurringPaymentOtherMeans = '28',
}
